import { Component, OnInit, computed } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Services
import { ClubECardService } from '@core/services/club/ecard.service';
import { SessionService } from '@core/services/session.service';
import { ImageService } from '@core/services/image.service';

// Components
import { UiLoading } from '@components/ui/loading/loading';
import { UiBadge } from '@components/ui/badge/badge';
import { UiButton } from '@components/ui/button/button';

/**
 * E-card — carte publique affichée via une clé passée en query param.
 * Reproduit visuellement la carte de visite (`app-visitcard`) sans session ni actions.
 */
@Component({
	selector: 'club-ecard',
	imports: [UiLoading, UiBadge, UiButton],
	templateUrl: './ecard.html',
	styleUrl: './ecard.scss',
})
export class ClubECard implements OnInit {
	static dialog = false;
	key: string;

	readonly loading: ClubECardService['loading'];
	readonly cardData = computed(() => this.ecard.data()?.cardData);
	readonly photo = computed(() => this.ecard.data()?.photo);
	readonly clubIcon = computed(() => this.imageService.getAppIcon(this.session.get<number>('nomdt') ?? 0));
	readonly clubName = computed(() => this.session.get<string>('displayevent') || this.session.get<string>('mandant') || '');
	readonly isMember = computed(() => this.cardData()?.ismember === true);
	readonly initials = computed(() => {
		const card = this.cardData();
		return `${card?.prenom?.charAt(0) ?? ''}${card?.nom?.charAt(0) ?? ''}`.toUpperCase();
	});

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private ecard: ClubECardService,
		private session: SessionService,
		private imageService: ImageService,
	) {
		this.key = this.route.snapshot.queryParamMap.get('key') ?? '';
		this.loading = this.ecard.loading;
	}

	ngOnInit(): void {
		this.ecard.load(this.key);
	}

	goBack(): void {
		this.router.navigate(['/']);
	}
}
